import React from "react";
import { styled } from "@mui/system";
import VerifiedIcon from "@mui/icons-material/Verified";

const Container = styled("section")({
  display: "flex",
  flexDirection: "column",
  "@media (max-width: 1020px)": {
    alignItems: "center",
  },
});

const InfoContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "30px",
});

const Subtitle5 = styled("h5")({
  fontSize: "12px",
  fontWeight: "500",
  color: "var(--color-light)",
});

const Title = styled("h1")({
  fontSize: "30px",
  color: "var(--color-primary)",
});

const Sep = styled("span")({
  border: "1px solid #4db5ff30",
  width: "60%",
  marginTop: "10px",
});

const Cards = styled("div")({
  display: "flex",
  justifyContent: "center",
  "@media (max-width: 1020px)": {
    flexDirection: "column",
    width: "70%",
  },
  "@media (max-width: 480px)": {
    flexDirection: "column",
    width: "90%",
  },
});

const Card = styled("span")({
  display: "flex",
  flex : 1,
  flexDirection: "column",
  padding: "20px",
  margin: "20px",
  borderRadius: "10px",
  backgroundColor: "var(--color-bg-variant)",
  gap: "10px",
  minWidth: "25%",
  transition: "all 1s ease",
  "&:hover": {
    backgroundColor: "#1f1f38",
    border: "1px solid var(--color-primary)",
    transform: "scale(1.05)",
  },
  "@media (max-width: 480px)": {
    gap: "0px",
  },
});

const CardDescription = styled("span")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "5px",
});

const Subtitle3 = styled("h3")({
  fontSize: "18px",
  fontWeight: "500",
});

const CardContent = styled("span")({
  display: "flex",
  "@media (max-width: 480px)": {
    flexDirection: "column",
  },
});

const SkillsList = styled("ul")({});
const Skill = styled("li")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  margin: "20px",
  "@media (max-width: 1020px)": {
    margin: "20px 0px 0px 0px",
  },
});
const Content = styled("span")({
  fontSize: "16px",
  fontWeight: "600",
});
const CardContentSide = styled("span")({
  flex: 1,
});

function Experience() {
  return (
    <Container id="experience">
      <InfoContainer>
        <Subtitle5>What skills I have</Subtitle5>
        <Title>My experience</Title>
      </InfoContainer>
      <Cards>
        {/* Full-Stack Development */}
        <Card>
          <CardDescription>
            <Subtitle3>Full-Stack Development</Subtitle3>
            <Sep />
          </CardDescription>
          <CardContent>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>HTML/ CSS/ JavaScript</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>ReactJS</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Python/ Django</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>PHP</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Java/ C#</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>PostgreSQL/ MySQL</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
          </CardContent>
        </Card>

        {/* Machine Learning / AI */}
        <Card>
          <CardDescription>
            <Subtitle3>Machine Learning / AI</Subtitle3>
            <Sep />
          </CardDescription>
          <CardContent>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Deep Learning</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Supervised/ Unsupervised Learning</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Computer Vision</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Predictive Models & Recommenders</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>NLP/ LLM</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>TensorFlow/ Keras/ PyTorch</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
          </CardContent>
        </Card>

        {/* DevOps & Cloud */}
        <Card>
          <CardDescription>
            <Subtitle3>DevOps & Cloud</Subtitle3>
            <Sep />
          </CardDescription>
          <CardContent>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Git / CI-CD</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>Docker / Kubernetes</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
            <CardContentSide>
              <SkillsList>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>AWS / Cloud</Content>
                </Skill>
                <Skill>
                  <VerifiedIcon style={{ color: "var(--color-primary)" }} />
                  <Content>MLOps & Pipeline Automation</Content>
                </Skill>
              </SkillsList>
            </CardContentSide>
          </CardContent>
        </Card>
      </Cards>
    </Container>
  );
}

export default Experience;
